<div class="row">
    <div class="col-12">
        <div id="clientList" class="card">
            <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems" [serviceData]="serviceData"
                (buttonActionSelected)="buttonActionSelected($event)" (updateCheckedValues)="checkedValGet =  $event"
                (rowActionSelected)="rowActionSelected($event)"
                (filterSelected)="filterSelected($event)"></app-list-layout>
        </div>
    </div>
</div>